var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResourceStability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.5748L5.59727 3.9373H8.37813L7 1.5748ZM3.77617 7.0873H10.1992L9.06719 5.11855H4.9082L3.77617 7.0873ZM3.08711 8.26855L2.15195 9.84355H11.8234L10.8883 8.26855H3.08711ZM5.96641 0.984179C6.43398 0.196679 7.54141 0.196679 8.00898 0.984179L12.8324 9.25293C13.3 10.0404 12.734 11.0248 11.8234 11.0248H2.15195C1.24141 11.0248 0.67539 10.0404 1.14297 9.25293L5.96641 0.984179Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceStability);
export default __webpack_public_path__ + "static/media/resource-stability.382e9b836a2c4d7420356b4763816d75.svg";
export { ForwardRef as ReactComponent };